/* Marks images that are still loading so the skeleton shows; removes the mark as soon as they paint */
(function () {
  if (window.__sySkel) return; window.__sySkel = true;
  var skip = '.sy-logo, .sy-tab, .sy-back, .shopify-pc__banner, [data-no-skel]';
  function done(e) { e.target.classList.remove('sy-ld'); }
  function mark(img) {
    if (!img || img.tagName !== 'IMG' || img.__syS) return;
    img.__syS = true;
    if (img.closest && img.closest(skip)) return;
    if (img.complete && img.naturalWidth) return;
    img.classList.add('sy-ld');
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }
  function scan(root) {
    if (root.tagName === 'IMG') mark(root);
    if (root.querySelectorAll) root.querySelectorAll('img').forEach(mark);
  }
  function init() {
    scan(document);
    new MutationObserver(function (list) {
      list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
